// extracted by mini-css-extract-plugin
export default {"bar":"QyfTws","headline":"FqEhob"};